/**
 * RSA 加密工具（与后端约定：RSA/ECB/PKCS1Padding，公钥加密，base64 输出）
 * 业务使用：将业务入参 JSON.stringify 后调 rsaEncrypt 得到 base64 密文，
 * 作为接口 value 字段提交给后端。
 */
import JSEncrypt from 'jsencrypt'

/** 后端下发的公钥（PEM base64 内容，可不含头尾），与后端保持一致 */
const RSA_PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCX8tUbRo3kuhqkNLqDVWWeJuy9uavQtmFiAM/xuCpRZu9ufRfOYvCDHjdO3hVMSLiz2pNWYzcEh4cgfxCwRAjeY8uSqhJAPN5dQuEGhFNn1AQarD8bcU8TIkB2/HBMPWGjNFGF7bQwrb2pQ2ws9Cyy0V8tWsurzDqAbpRgD0HPSwIDAQAB'

/** 单例加密器：复用同一个 JSEncrypt 实例，避免重复 setPublicKey */
let encryptor = null
function getEncryptor() {
    if (encryptor) return encryptor
    encryptor = new JSEncrypt()
    encryptor.setPublicKey(RSA_PUBLIC_KEY)
    return encryptor
}

/**
 * 对字符串做 RSA 加密
 * @param {string} plain 明文字符串
 * @returns {string} base64 密文；入参为空 / 加密失败返回空字符串
 */
export function rsaEncrypt(plain) {
    if (plain == null || plain === '') return ''
    const text = String(plain)
    console.log('[rsa] 加密原文:', text)
    try {
        const result = getEncryptor().encrypt(text)
        return result || ''
    } catch (e) {
        console.error('[rsa] 加密失败:', e)
        return ''
    }
}

/**
 * 将业务参数对象 JSON.stringify 后做 RSA 加密，并包装成接口最终入参 { value }
 * @param {object} payload 业务参数对象
 * @returns {{ value: string }} 加密后的请求体
 */
export function buildEncryptedPayload(payload) {
    const plain = JSON.stringify(payload == null ? {} : payload)
    return { value: rsaEncrypt(plain) }
}
